import compose from 'lodash/fp/compose'
import withResponsiveVisibility from './withResponsiveVisibility'
import withGridContainer from './withGridContainer'
/**
 * withCapabilities Higher Order Component (HOC)
 *
 * This HOC composes multiple capabilities for a component, enhancing it with
 * additional functionalities. Currently, it applies the following capabilities:
 *
 * 1. Responsive Visibility: Allows the component to be conditionally rendered
 *    based on the current viewport size (e.g., hidden on mobile, visible on desktop).
 * 2. Grid Container: Adds Grid container functionality with spacing=2 by default
 *    when the gridContainer prop is provided.
 *
 * Usage:
 * import withCapabilities from './withCapabilities'
 *
 * const EnhancedComponent = withCapabilities(YourComponent)
 *
 * // With responsive visibility
 * <EnhancedComponent mobileOnly />
 * <EnhancedComponent desktopOnly />
 *
 * // With Grid container
 * <EnhancedComponent gridContainer>
 *   <div>Content</div>
 * </EnhancedComponent>
 *
 * // With custom Grid props
 * <EnhancedComponent gridContainer={{ spacing: 3, direction: 'column' }}>
 *   <div>Content</div>
 * </EnhancedComponent>
 *
 * This will apply all capabilities to YourComponent, making it responsive
 * and adding Grid container functionality.
 */

const withCapabilities = compose(withResponsiveVisibility, withGridContainer)

export default withCapabilities
